module.exports = __webpack_public_path__ + "img/RUS.17f60b26.png";